<template>
  <container title='租金营收排名' :loading='loading' :nodata='nodata' style='height: 404px;'>
    <div class="ranking-item ranking-title">
      <div class="first">
        排名
      </div>
      <div class="third">
        租金营收（元）
      </div>
      <div class="second">
        管理单位
      </div>
    </div>
    <div class="ranking-item" v-for="(item,index) in list" :key='index'>
      <div class="first">
        {{index+1}}
      </div>
      <div class="third">
        {{item.rentMoney |moneyD}}
      </div>
      <div class="second">
        <el-tooltip placement="top">
            <span style='cursor: pointer;' @click='torent(item)' slot="content">
              {{item.companyName}}
            </span>
          <div class='one-txt-cut'>
           <span style='cursor: pointer;' @click='torent(item)'>
              {{item.companyName}}
            </span>
          </div>
        </el-tooltip>
      </div>
    </div>
  </container>
</template>

<script>
  import container from "../container";
  import {getRentMoneySort} from "../../../../../api/bigData";

  export default {
    name: "rentRevenueranking",
    components: {
      container,
    },
    data() {
      return {
        list:[],
        loading:false,
        nodata:false,
      }
    },
    methods: {
      torent(item){
        let query={companyId:item.companyId,companyName:item.companyName,}
        this.$router.push({path: '/rent',query })
      },
      getList(){
        this.loading=true
        getRentMoneySort({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.loading=false
            this.list=data.content
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading=false
          this.nodata=!this.list.length
        })
      },
    },
    created() {
      this.getList()
    },
    filters:{
      moneyD:(money) => {
        if (money == ''){
          return money
        }else{
          if(money != null && money != 'undefined'){
            money = money.toString().replace(/,/g, "");
          }
          let num = parseFloat(money);
          let strNum = parseFloat("a");
          if (num.toString() != strNum.toString()){
            num = num.toLocaleString()
            return num
          }else{
            return money
          }
        }
      }
    },
  }
</script>

<style scoped lang="scss">
  .ranking-item{
    padding-left: 15px;
    color: #B8D7FF;
    font-size: 18px;
    white-space: nowrap;
    margin-bottom: 14px;
    line-height: 25px;
    overflow: hidden;
    .first{
      width: 36px;
      margin-right: 13.713%;
      text-align: center;
      float: left;
    }
    .second{
      padding-right: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .third{
      width: 46.5182%;
      text-align: center;
      max-width: 128px;
      float: right;
    }
    &:last-child{
      margin-bottom: 10px;
    }
  }
  .ranking-title{
    color: #2D6BF4;
    font-size: 17px;
    font-weight: 600;
    font-family:PingFangSC-Semibold,PingFang SC;
    line-height:23px;
    margin: 28px 0;
  }
</style>
